export default "__VITE_ASSET__D1N8r4kh__ 300w";